import { type CardContent, type ContentComponent, type LinkContent } from '../../../../types/construct.types';
import { generateWidthClasses, calculateItemsPerRow } from '../../../../utils/construct.utils';
import { LinkButton } from '../../../buttons/link-button/link-button.component';
import { Link } from '../../../common-components/link/link.component';
import { PartialWidthGraphImage } from '../../../images/graph-images/partial-width-graph-image/partial-width-graph-image';

type ShowcaseCardCardFields = {
	'cta-secondary': LinkContent;
};

export type ShowcaseCardContent = CardContent & {
	cardFields: ShowcaseCardCardFields;
};

export const ShowcaseCard: ContentComponent<ShowcaseCardContent> = ({ content, options }) => {
	const { cardFields, image, url } = content;

	if (image?.id == null || url == null) {
		return null;
	}

	const itemsPerRow = calculateItemsPerRow(options);
	const widthClasses = generateWidthClasses(itemsPerRow);

	return (
		<div className={`flex flex-column pa2 ${widthClasses}`}>
			<Link url={url} ariaLabel="article image">
				<PartialWidthGraphImage image={image} perRow={itemsPerRow} />
			</Link>
			<div>
				<div className="flex flex-column flex-row-ns ga3 mt3 w-100">
					<LinkButton buttonStyle="SECONDARY" url={url} automationHook="read-the-article">
						READ THE ARTICLE
					</LinkButton>
					<LinkButton buttonStyle="SECONDARY" url={cardFields['cta-secondary'].linkUrl} automationHook="shop-the-products">
						SHOP THE PRODUCTS
					</LinkButton>
				</div>
			</div>
		</div>
	);
};
